<template>
  <v-overlay
    contained
    :scrim="scrim"
    :model-value="loading"
  >
    <ThunderLoader
      :width="width"
      :height="height"
    />
  </v-overlay>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ThunderLoader from '@/components/ThunderLoader.vue'

/**
 * Section-scoped loading overlay: dims a container and centres the Thunderstock
 * bolt over it while its data loads.
 *
 * `contained` is what keeps the overlay inside its container. Without it Vuetify
 * teleports the overlay to `.v-overlay-container` at body level, where it covers
 * the whole viewport and swallows clicks on the navbar and sidebar. `contained`
 * renders it in place and switches the scrim to `position: absolute`, so the
 * nearest positioned ancestor bounds it — give that ancestor `p-relative` (or use
 * an element that is already relative, such as `v-card`).
 */
export default defineComponent({
  name: 'TsLoadingOverlay',
  components: { ThunderLoader },
  props: {
    /** Whether the overlay is shown. */
    loading: {
      type: Boolean,
      default: false
    },
    /** Scrim colour painted over the container. */
    scrim: {
      type: String,
      default: 'white'
    },
    /** Loader width; defaults to ThunderLoader's own sizing. */
    width: {
      type: String,
      default: undefined
    },
    /** Loader height; defaults to ThunderLoader's own sizing. */
    height: {
      type: String,
      default: undefined
    }
  }
})
</script>
